import { Layout } from "../../components/common/Layout";
import { RiskGroup } from "../../components/analytics/RiskGroup";

export const RiskGroupPage = () => {

    const title = "Группа риска";
    
    return (
        <Layout title={title}>
            <RiskGroup />
        </Layout>
    )
}